
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Link } from 'office-ui-fabric-react/lib/Link';

import Text from '../../common/client/components/Text';

import categoryGetActions from '../../sagas/category';
import DialogConfirm from '../common/DialogConfirm';
import DialogEditCategoryItem from './DialogEditCategoryItem';

const classNames = mergeStyleSets({
    title: {
    },
    legendColor: {
        width: 32,
        height: 16,
        border: '1px solid #777777'
    },
    tools: {
    }
});

const CategoryItem = (props) => {

    const dispatch = useDispatch();
    const categoryActions = categoryGetActions(dispatch);

    const token = useSelector(state => {
        return state.auth.data ? state.auth.data.user.token : null;
    });

    const projectId = useSelector(state => {
        return state.project.data.project.id;
    });

    const handleDeleteClick = async () => {
        const message = `Opravdu chcete smazat položku kategorie parcel "${props.item.item_title}"?`;

        let confirm = await DialogConfirm.show(message);
        if (confirm) {
            categoryActions.deleteCategoryItem(
                token, projectId, props.actualCategoryName, props.item.item_name
            );
        }
    }

    const handleEditClick = async () => {
        const data = await DialogEditCategoryItem.show(props.item.item_color, props.item.item_title);
        if (data) {
            categoryActions.editCategoryItem(
                token, projectId, props.actualCategoryName, props.item.item_name, data.title, data.color
            );
        }
    }

    const color = props.item.item_color
        ? `rgba(${props.item.item_color.split(' ').join(',')},0.7)`
        : null;

    return (
        <Stack horizontal tokens={{childrenGap: 8}}>
            <Stack.Item grow className={classNames.title}>
                {props.item.item_title}
            </Stack.Item>
            <Stack.Item className={classNames.itemColor}>
                <div className={classNames.legendColor} style={{backgroundColor: color}} />
            </Stack.Item>
            <Stack.Item className={classNames.tools}>
                <Stack horizontal tokens={{childrenGap: 4}}>
                    <Link onClick={handleDeleteClick} title="Smazat položku kategorie">Smazat</Link>
                    <Link onClick={handleEditClick} title="Upravit položku kategorie">Upravit</Link>
                </Stack>
            </Stack.Item>
        </Stack>
    );
}

const CategoryItems = (props) => {
    return (
        <Stack tokens={{childrenGap: 8}}>
            {(props.categoryItems)
                ? props.categoryItems.map(item => {
                    return (
                        <CategoryItem
                            key={item.item_name}
                            item={item}
                            actualCategoryName={props.actualCategoryName}
                        />
                    );
                })
                : <Text>Kategorie parcel zatím neobsahuje žádnou položku</Text>
            }
        </Stack>
    );
}

export default CategoryItems;
